import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useDispatch } from 'react-redux';
import { AccordionButtonStyle, AccordionDisplay, TypographyStyle } from './FilterStyle';
import { pushComponentString, pushCheckboxData, pushShowCard, setAccordionOpen, pushChipArray, pushSearchChipArray, setSearchString } from '../../slices/RiskFilterSlice';
import { pushAddOperation } from '../../slices/OperationCardSlice';
import { operationsNamesArray, riskTypeOperations, riskTypeData } from '../../constants/constants';
import styled from 'styled-components';
import { getRiskApiResponse, getApiResponse } from '../../slices/recommendationTableSlice';
const StyledAccordion = styled(Accordion)`
  && {
    box-shadow: 0px 0px;
  }
`;

const RenderAccordion = ({
  accordionValue,
  setRowsPerPage
}) => {
  const {
    accordionKey,
    accordionName
  } = accordionValue;
  const dispatch = useDispatch();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      border: 'none'
    }
  }, /*#__PURE__*/React.createElement(StyledAccordion, null, /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header"
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(TypographyStyle, null, accordionKey))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(AccordionDisplay, null, accordionName.map((buttonItem, index) => {
    return /*#__PURE__*/React.createElement(AccordionButtonStyle, {
      key: index,
      name: buttonItem,
      value: buttonItem,
      variant: "light",
      onClick: e => {
        dispatch(setAccordionOpen(true));
        let selectedComponent = e.currentTarget.value;
        dispatch(pushChipArray([]));
        dispatch(pushSearchChipArray([]));
        dispatch(setSearchString(''));
        dispatch(pushComponentString(selectedComponent));

        if (selectedComponent && selectedComponent.length > 0) {
          dispatch(pushShowCard(true));
        }

        let data = {
          data: '',
          type: 'search'
        };
        dispatch(getRiskApiResponse(data));
        let pageData = {
          data: '',
          type: 'paginationData'
        };
        dispatch(getApiResponse(pageData));
        setRowsPerPage(10);

        if (selectedComponent.includes('Risk')) {
          dispatch(pushAddOperation(riskTypeOperations));
          dispatch(pushCheckboxData(riskTypeData));
        } else if (selectedComponent) {
          dispatch(pushAddOperation(operationsNamesArray));
        }
      }
    }, buttonItem);
  })))));
};

const ComponentCard = ({
  accordionKeyItems,
  setRowsPerPage
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, accordionKeyItems.map((accordionValue, index) => {
    return /*#__PURE__*/React.createElement(RenderAccordion, {
      accordionValue: accordionValue,
      key: index,
      setRowsPerPage: setRowsPerPage
    });
  }));
};

export default ComponentCard;